// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"19":"54c4b231","227":"ca249812","869":"59e9043b"}[chunkId] + ".js";
};